import { Card, OutlinedButton, TextHeader } from '@Iot-Bee/standard-web-library';
import React from 'react';
import { PageSection, SectionText } from '../util';
import { Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * @deprecated This is the initial dashboard we had, all clients should have KWH devices, it is just to be compatible with old clients.
 * @returns
 */
const NoKWHdevicesDashboard = () => {
  const navigate = useNavigate();

  return (
    <Card title="Welcome and get started">
      <PageSection>
        <TextHeader>Your devices</TextHeader>
        <SectionText>See all of your devices and manage your data right here in the Hive.</SectionText>
        <OutlinedButton onClick={() => navigate('devices')}>Manage your devices</OutlinedButton>
      </PageSection>
      <Divider />
      <PageSection>
        <TextHeader>Setup alerts</TextHeader>
        <SectionText>
          Setup alerts and automatic alarms on you devices - or simply connect your data with your API through HTTP
          requests.
        </SectionText>
        <OutlinedButton onClick={() => navigate('alerts')}>Setup alerts</OutlinedButton>
      </PageSection>
      <Divider />
      <PageSection>
        <TextHeader>Need any help</TextHeader>
        <SectionText>
          If you need any help then feel free to contact us at contact@iotbee.net or +4551531632.{' '}
        </SectionText>
        <OutlinedButton>Contact support</OutlinedButton>
      </PageSection>
    </Card>
  );
};

export default NoKWHdevicesDashboard;
